module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jDkgJ"))).then(() => module.bundle.root('gtEzC'));